import { MessageHandlerBase } from "./MessageHandlerBase";
const ContinueSessionAppEvent = "ConsumerCenterContinueSession";
export default class ContinueSessionHandler extends MessageHandlerBase {
    handle(message) {
        if (!this.almeState.sessionExpired && this.almeState.isOpen) {
            this.sendAppEvent(message, ContinueSessionAppEvent);
        }
    }
}
